import {
  APIComponentAttributes,
  APIEntityType,
  APIFieldType,
  APIReferenceAttributes,
} from './apiTypes';
import { ArdoqId } from './coreTypes';

export type AuditLogAPIResponse = {
  results: Array<APIAuditLogRowData>;
  pageState: PageState;
  morePages: boolean;
};

export type PageState = {
  pageNumber: number;
  newerPageToken?: string;
  olderPageToken?: string;
};

export type APIAuditLogRowData = {
  action: AuditLogAction;
  user: ArdoqId;
  userName: string | null;
  userEmail: string | null;
  timestamp: string;
  entityId: ArdoqId;
  entityType: AuditLogEntityType;
  entityName: string;
  entityVersion: number;
  entityPath: Array<string>;
  approvedBy?: ArdoqId;
  changes: Array<APIAuditLogChangeType>;
  component?: AuditLogComponent;
  reference?: AuditLogReference;
  areEmptyChanges: boolean;
  cannotUndoDeleteReason: string | null;
  surveyId: ArdoqId | null;
  requestedBy: ArdoqId[] | null;
};

export enum AuditLogAction {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}

export type AuditLogEntityType = (typeof auditLogEntityTypesList)[number];

export const auditLogEntityTypesList = [
  APIEntityType.WORKSPACE,
  APIEntityType.COMPONENT,
  APIEntityType.COMPONENT_TYPE,
  APIEntityType.REFERENCE,
  APIEntityType.REFERENCE_TYPE,
  APIEntityType.FIELD,
] as const;

export type AuditLogComponent = {
  type: string;
};

export type AuditLogReference = {
  source: string;
  target: string;
  type: string;
  rootWorkspace: string;
  targetWorkspace: string;
};

type APIAuditLogChange<T> = {
  field: string;
  fieldLabel: string;
  dataType: APIFieldType;
  numberFormatOptions?: string;
  before: T | null;
  after: T | null;
  isRestorable?: boolean;
  restorableValue?:
    | APIComponentAttributes[keyof APIComponentAttributes]
    | APIReferenceAttributes[keyof APIReferenceAttributes];
  notRestorableReason?: string;
};

export type RestoreComponentPayload = {
  component: ArdoqId;
};

export type RestoreReferencePayload = {
  reference: ArdoqId;
};

export type APIAuditLogChangeType =
  | APIAuditLogChange<string>
  | APIAuditLogChange<number>
  | APIAuditLogChange<boolean>;
